import api from "../../config/apiConfig";

const getAllAIF = async (data: any) => {
  // // console.logF Service', accessToken);
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("/aif/getAll", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data.data;
};

const mfService = { getAllAIF };
export default mfService;
